import { render } from "./InternshipCard.vue?vue&type=template&id=08a1b419"
import script from "./InternshipCard.vue?vue&type=script&lang=js"
export * from "./InternshipCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__